const ArrowLeftCalendar = props => (
	<svg
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		className="flip-if-rlt"
	>
		<path
			d="M18.5083 3.77L16.7383 2L6.73828 12L16.7383 22L18.5083 20.23L10.2783 12L18.5083 3.77Z"
			fill="currentColor"
		/>
	</svg>
);

export default ArrowLeftCalendar;
